import { useMutation, gql } from '@apollo/client';
import {
  CadastrarFeriadoMutation,
  CadastrarFeriadoMutationVariables,
} from './__generated__/CadastrarFeriadoMutation';

const CADASTRAR_FERIADO_MUTATION = gql`
  mutation CadastrarFeriadoMutation($dsc_feriado: String!, $dat_feriado: String!) {
    cadastrarFeriado(input: { dsc_feriado: $dsc_feriado, dat_feriado: $dat_feriado }) {
      id_feriado
      dsc_feriado
      dat_feriado
    }
  }
`;

const useCadastrarFeriadoMutation = () => {
  return useMutation<CadastrarFeriadoMutation, CadastrarFeriadoMutationVariables>(
    CADASTRAR_FERIADO_MUTATION
  );
};

export { useCadastrarFeriadoMutation };
